module.exports = __webpack_public_path__ + "img/cost-icon__salon_eventos.00903978.svg";